import { datesToISO } from "@";

// Payload for search values
export const searchValuesPayload = ({
  page,
  toDate,
  toAmount,
  pageSize,
  fromDate,
  fromAmount,
  projectTitle,
  classificationId,
  isRecentPaymentExists,
}) => ({
  page,
  projectTitle,
  pageSize: pageSize,
  toDate: datesToISO(toDate),
  amountTo: parseInt(toAmount),
  fromDate: datesToISO(fromDate),
  amountFrom: parseInt(fromAmount),
  classificationId: parseInt(classificationId),
  isRecentPaymentExists: isRecentPaymentExists || false,
});
